export const ARCHIVE_PATH = "/archive";
export const SCHEDULED_PATH = "/scheduled";
